export default "/images/vendor/flag-icon-css/flags/1x1/ng.svg?caaf41205a6fde2a18533c696a971248";